import { WidgetType } from 'widgets/WidgetType';
import { selectEstimatedTradeCostComparisonWidgetState } from './selectors';
import {
    buildComponentSlice,
    useComponentSlice,
} from 'widgets/store/component/componentSlice';
import {
    EstimatedTradeCostComponentState,
    initialEstimatedTradeCostComponentState,
} from 'widgets/estimatedTradeCost/widget/store/componentSlice';

export type EstimatedTradeCostComparisonComponentState =
    EstimatedTradeCostComponentState;

const initialEstimatedTradeCostComparisonComponentState: EstimatedTradeCostComparisonComponentState =
    initialEstimatedTradeCostComponentState;

export const buildEstimatedTradeCostComparisonWidgetComponentSlice = () =>
    buildComponentSlice<EstimatedTradeCostComparisonComponentState>(
        WidgetType.EST_TRADE_COST_COMPARISON_WIDGET,
        selectEstimatedTradeCostComparisonWidgetState,
        initialEstimatedTradeCostComparisonComponentState
    );

export const useEstimatedTradeCostComparisonWidgetComponentSlice = () =>
    useComponentSlice(buildEstimatedTradeCostComparisonWidgetComponentSlice());
